module.exports = __webpack_public_path__ + "static/media/number_widget_icon.40947edd.svg";